(() => {
  const core = window.CjsFulfilment;
  const calendar = window.CjsFulfilmentCalendar;
  const initial = document.querySelector('[data-cjs-fulfilment-data]');
  if (!core || !initial || window.cjsFulfilmentController) return;
  window.cjsFulfilmentController = true;
  let data;
  const parseData = (text) => {
    const value = JSON.parse(text);
    value.clockReceivedAt = Date.now();
    for (const item of value.items) {
      if (Array.isArray(item.properties)) item.properties = Object.fromEntries(item.properties);
    }
    // The aggregate-quantity Flow cannot detect same-total location transfers.
    // Saved counts are configuration only when the fresh location reader is enabled.
    for (const variant of [value.product, ...value.items.map(item => item.variant)]) {
      if (core.isManaged(variant)) variant.managed = true;
    }
    if (value.liveAvailabilityBaseUrl || value.liveAvailabilityUrl) clearAvailability(value);
    return value;
  };
  function clearAvailability(value) {
    if (value.product) value.product.fulfilment = null;
    for (const item of value.items) if (item.variant) item.variant.fulfilment = null;
  }
  try { data = parseData(initial.textContent); } catch { return; }
  let refreshing;
    let availabilityLoading = true;
  let observedProductVariant = String(data.product?.id || '');
  let variantRefreshQueued = false;
  let frame;
  let allowCheckout = false;
  let checkoutBusy = false;
  const setText = (element, value) => {
    if (element && element.textContent !== value) {
      element.textContent = value;
      delete element.dataset.cjsAvailabilityContent;
    }
  };
  const snapshotPropertyNames = () => [...new Set([data.messages.property_name, data.messages.expected_dispatch_name, data.messages.order_fulfilment_name, 'Expected dispatch'])];
  const hasSavedSnapshot = entry => entry.properties?._cjs_availability_notes ||
    entry.properties?.[data.messages.order_fulfilment_name] === data.messages.order_fulfilment ||
    ['Available to order', 'Special order'].includes(entry.properties?.[data.messages.property_name]);
  const currentTimestamp = () => Number(data.serverTime) * 1000 + Date.now() - data.clockReceivedAt;
  function snapshotProperties(state) {
    if (state.state === 'workshop' || state.state === 'unmanaged') return {};
    const properties = { [data.messages.property_name]: data.messages[state.state + '_label'] || data.messages.unknown_label };
    if (state.state === 'supplier') {
      properties[data.messages.expected_dispatch_name] = state.dispatchDate ? `~${calendar.formatDate(state.dispatchDate, currentTimestamp())}` :
        data.messages.supplier_dispatch_window.replace('[min]', state.minBusinessDays).replace('[max]', state.maxBusinessDays);
      properties[data.messages.order_fulfilment_name] = data.messages.order_fulfilment;
    }
    return properties;
  }
  function setProperties(form, properties) {
    for (const name of snapshotPropertyNames()) {
      let input = Array.from(form.querySelectorAll('input')).find(element => element.name === `properties[${name}]`);
      if (!(name in properties)) { input?.remove(); continue; }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        form.append(input);
      }
      input.dataset.cjsDispatchProperty = '';
      input.name = `properties[${name}]`;
      input.value = properties[name];
    }
  }
  function deliveryFor(state) {
    const range = state.dispatchDate && calendar?.deliveryRange(data.schedule, state.dispatchDate);
    return range ? `~${calendar.formatRange(range, currentTimestamp())}` : data.messages.supplier_delivery_window;
  }
  function renderAvailability(element, state, summary = false, productNote = false) {
    const properties = snapshotProperties(state);
    const signature = JSON.stringify({ properties, summary, productNote, message: messageFor(state), delivery: state.state === 'supplier' ? deliveryFor(state) : null });
    if (element.dataset.cjsAvailabilityContent === signature) return;
    element.dataset.cjsAvailabilityContent = signature;
    element.replaceChildren();
    if (state.state === 'workshop') return;
    const row = (tag, text) => {
      const node = document.createElement(tag);
      node.style.display = 'block';
      node.style.margin = '0 0 0.35em';
      node.textContent = text;
      element.append(node);
      return node;
    };
    const estimateRow = (label, value) => {
      if (!productNote) return row('span', `${label}: ${value}`);
      const node = row('span', '');
      const heading = document.createElement('strong');
      heading.textContent = `${label}: `;
      node.append(heading, document.createTextNode(value));
      return node;
    };
    if (!productNote) row('strong', properties[data.messages.property_name]);
    const dispatch = properties[data.messages.expected_dispatch_name];
    if (dispatch) estimateRow(data.messages.expected_dispatch_name, dispatch);
    else row('span', messageFor(state));
    if (state.state === 'supplier') {
      if (productNote) {
        estimateRow(data.messages.expected_delivery_name, deliveryFor(state));
        row('small', data.messages.standard_shipping_note);
      } else row('span', `${data.messages.expected_delivery_name}: ${deliveryFor(state)} (${data.messages.standard_shipping})`);
      if (summary) row('span', data.messages.cart_wait);
    }
  }
  function productVariant(form) {
    const id = String(new FormData(form).get('id'));
    return data.product?.id && String(data.product.id) === id ? data.product : data.items.find(item => String(item.variantId) === id)?.variant;
  }
  function dated(state, variant) {
    if (state.state !== 'supplier' || !calendar || !data.schedule ||
        !variant?.fulfilment?.suppliers.every(supplier => supplier.available <= 0 || String(supplier.locationId) === data.schedule.supplierLocationId)) return state;
    const serverTime = Number(data.serverTime);
    if (!Number.isFinite(serverTime) || serverTime <= 0) return state;
    const now = currentTimestamp();
    const estimate = calendar.estimate(data.schedule, now);
    return estimate ? { ...state, ...estimate } : state;
  }
  function orderState() {
    return core.cartState(data.items, dated);
  }
  function messageFor(state) {
    return state.dispatchDate ? data.messages.supplier_dispatch_date.replace('[date]', calendar.formatDate(state.dispatchDate, currentTimestamp())) : core.dispatchMessage(state, data.messages);
  }
  function update() {
    const totals = core.variantQuantities(data.items);
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      const id = String(new FormData(form).get('id'));
      const variant = productVariant(form);
      if (!core.isManaged(variant)) {
        // A section refresh can unenrol a variant while its product form remains on screen.
        const formerSection = form.closest('[data-cjs-location-fulfilment="true"]');
        if (formerSection && !variant && availabilityLoading) {
          setText(formerSection.querySelector('[data-cjs-stock-status-label]'), data.messages.loading_label);
          const button = form.querySelector('[name="add"]');
          if (button) button.disabled = true;
        }
        if (!formerSection || !variant) return;
        setProperties(form, {});
        const stock = formerSection.querySelector('[data-cjs-stock-status]');
        setText(formerSection.querySelector('[data-cjs-stock-status-label]'),
          variant.available ? data.messages.workshop_label : data.messages.unavailable_label);
        stock?.classList.remove('cjs-product-main__stock--purchase-option-warehouse');
        stock?.classList.toggle('cjs-product-main__stock--sold-out', !variant.available);
        const note = formerSection.querySelector('[data-cjs-dispatch-message]');
        if (note) { note.hidden = true; note.replaceChildren(); }
        formerSection.querySelectorAll('[data-cjs-location-pickup]').forEach(element => { element.hidden = true; setText(element, ''); });
        const button = form.querySelector('[name="add"]');
        if (button && !button.classList.contains('loading')) button.disabled = !variant.available;
        return;
      }
      const requested = Number(new FormData(form).get('quantity') || 1);
      const state = dated(core.resolve(productVariant(form) || { id }, requested + (totals.get(id) || 0)), productVariant(form));
      const message = messageFor(state);
      setProperties(form, snapshotProperties(state));
      const section = form.closest('[data-cjs-location-fulfilment="true"]');
      if (!section) return;
      const stock = section.querySelector('[data-cjs-stock-status]');
      setText(section.querySelector('[data-cjs-stock-status-label]'),
        availabilityLoading && state.state === 'unknown' ? data.messages.loading_label : core.stockLabel(variant, state, data.messages));
      if (stock) {
        stock.classList.toggle('cjs-product-main__stock--sold-out', state.state === 'unavailable');
        stock.classList.toggle('cjs-product-main__stock--purchase-option-warehouse', state.state === 'supplier');
      }
      const dispatchElement = section.querySelector('[data-cjs-dispatch-message]');
      if (dispatchElement) dispatchElement.hidden = state.state === 'workshop';
      if (dispatchElement && state.state === 'supplier') renderAvailability(dispatchElement, state, false, true);
      else setText(dispatchElement, state.state === 'workshop' ? '' : message);
      const pickup = state.dispatchDate ? data.messages.supplier_pickup_date.replace('[date]', calendar.formatDate(state.dispatchDate, currentTimestamp())) : data.messages[state.state + '_pickup'] || data.messages.unknown_pickup;
      section.querySelectorAll('[data-cjs-location-pickup]').forEach((element) => { element.hidden = false; setText(element, pickup.replace('[min]', state.minBusinessDays).replace('[max]', state.maxBusinessDays)); });
      const button = form.querySelector('[name="add"]');
      if (button && !button.classList.contains('loading')) {
        const unavailable = state.state === 'unknown' || state.state === 'unavailable' || !productVariant(form)?.available;
        if (button.disabled !== unavailable) button.disabled = unavailable;
      }
    });
    const order = orderState();
    document.querySelectorAll('[data-cjs-cart-dispatch]').forEach((element) => {
      const hidden = order.state === 'unmanaged' || order.state === 'workshop';
      if (element.hidden !== hidden) element.hidden = hidden;
      if (!hidden) {
        renderAvailability(element, order, true);
      }
    });
    document.querySelectorAll('[data-cjs-line-dispatch]').forEach((element) => {
      const item = data.items.find((entry) => entry.key === element.dataset.cjsLineDispatch);
      if (!core.isManaged(item?.variant)) { element.hidden = true; element.replaceChildren(); return; }
      const state = dated(core.resolve(item.variant, totals.get(String(item.variantId))), item.variant);
      element.hidden = state.state === 'workshop';
      renderAvailability(element, state);
    });
  }
  function scheduleUpdate() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      const selected = document.querySelector('[data-cjs-location-fulfilment="true"] [name="id"]')?.value;
      if (selected && selected !== observedProductVariant) {
        observedProductVariant = selected;
        availabilityLoading = true;
        if (!variantRefreshQueued) {
          variantRefreshQueued = true;
          // Section replacement changes the hidden ID after the select event. Wait for an
          // older read before fetching the latest selection, collapsing rapid changes.
          Promise.resolve(refreshing).then(() => {
            variantRefreshQueued = false;
            return refresh();
          });
        }
      }
      update();
    });
  }
  async function saveDispatchSnapshot() {
    await refresh();
    const maximumAttempts = Math.max(20, data.items.length * 2 + 10);
    for (let attempt = 0; attempt < maximumAttempts; attempt++) {
      const state = orderState();
      if (state.state === 'unknown' || state.state === 'unavailable') throw new Error('Availability must be confirmed');
      const totals = core.variantQuantities(data.items);
      const desiredProperties = entry => {
        const line = core.resolve(entry.variant, totals.get(String(entry.variantId)));
        return snapshotProperties(line.state === 'supplier' ? state : line);
      };
      const item = data.items.find(entry => (core.isManaged(entry.variant) || hasSavedSnapshot(entry)) &&
        snapshotPropertyNames().some(name => entry.properties?.[name] !== desiredProperties(entry)[name]));
      const properties = item ? desiredProperties(item) : {};
      if (!item) return;
      const url = `${window.Shopify?.routes?.root || '/'}cart/change.js`;
      const updatedProperties = { ...item.properties };
      for (const name of snapshotPropertyNames()) delete updatedProperties[name];
      Object.assign(updatedProperties, properties);
      // Shopify cannot clear the last property with an empty object. Keep only a private marker.
      if (Object.keys(updatedProperties).length === 0) updatedProperties._cjs_availability_notes = 'cleared';
      const response = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: updatedProperties }) });
      if (!response.ok) throw new Error('Dispatch estimate could not be saved');
      await refresh();
    }
    throw new Error('Dispatch estimate could not be saved');
  }
  async function refresh() {
    if (refreshing) return refreshing;
    availabilityLoading = true;
    update();
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('section_id', 'cjs-fulfilment-data');
    const currentVariant = document.querySelector('[data-cjs-location-fulfilment="true"] [name="id"]')?.value;
    if (currentVariant) url.searchParams.set('variant', currentVariant);
    refreshing = (async () => {
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Availability request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = html.querySelector('[data-cjs-fulfilment-data]');
        if (!result) throw new Error('Availability data missing');
        data = parseData(result.textContent);
        update();
        if (data.liveAvailabilityBaseUrl || data.liveAvailabilityUrl) {
          await readLiveAvailability();
        }
      } catch {
        clearAvailability(data);
      } finally { refreshing = null; availabilityLoading = false; update(); }
    })();
    return refreshing;
  }
  async function readLiveAvailability() {
    const variants = new Map();
    for (const variant of [data.product, ...data.items.map(item => item.variant)]) {
      if (core.isManaged(variant)) variants.set(String(variant.id), variant);
    }
    const ids = [...variants.keys()];
    let cursor = 0;
    let failed = false;
    const reader = async () => {
      while (cursor < ids.length) {
        const id = ids[cursor++];
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const url = data.liveAvailabilityBaseUrl ? `${data.liveAvailabilityBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(id)}` : data.liveAvailabilityUrl;
          const response = await fetch(url, { credentials: 'omit', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Live availability request failed');
          const live = await response.json();
          const snapshot = live?.fulfilment;
          if (String(live?.id) !== id || typeof live.available !== 'boolean' ||
              !Number.isSafeInteger(live.inventoryQuantity) || snapshot?.inventoryQuantity !== live.inventoryQuantity ||
              snapshot?.version !== 1 || snapshot.enabled !== true || !Number.isSafeInteger(snapshot.workshop?.available) ||
              !Array.isArray(snapshot.suppliers) || snapshot.suppliers.length === 0 ||
              snapshot.suppliers.some(supplier => !Number.isSafeInteger(supplier.available) ||
                !Number.isSafeInteger(supplier.minBusinessDays) || supplier.minBusinessDays < 1 ||
                !Number.isSafeInteger(supplier.maxBusinessDays) || supplier.maxBusinessDays < supplier.minBusinessDays)) {
            throw new Error('Live availability data is invalid');
          }
          const apply = variant => {
            if (String(variant?.id) !== id) return;
            variant.inventoryQuantity = live.inventoryQuantity;
            variant.available = live.available;
            variant.fulfilment = snapshot;
          };
          apply(data.product);
          for (const item of data.items) apply(item.variant);
        } catch { failed = true; }
        finally { clearTimeout(timeout); }
      }
    };
    await Promise.all(Array.from({ length: Math.min(4, ids.length) }, reader));
    if (failed) throw new Error('Live availability could not be confirmed');
  }
  document.addEventListener('input', scheduleUpdate);
  document.addEventListener('change', scheduleUpdate);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    if (!core.isManaged(productVariant(form))) return;
    const id = String(new FormData(form).get('id'));
    update();
    const quantity = Number(new FormData(form).get('quantity') || 1) + (core.variantQuantities(data.items).get(id) || 0);
    if (['unknown', 'unavailable'].includes(core.resolve(productVariant(form), quantity).state)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('click', async (event) => {
    const button = event.target.closest('button[name="checkout"], button.bss-checkout, button[bss-b2b-default-checkout], a[href*="/checkout"]');
    if (!button || allowCheckout || core.cartState(data.items).state === 'unmanaged' && !data.items.some(hasSavedSnapshot) && !document.querySelector('[data-cjs-line-dispatch]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await saveDispatchSnapshot();
      allowCheckout = true;
      button.click();
    } catch {
      document.querySelectorAll('[data-cjs-cart-dispatch]').forEach(element => { element.hidden = false; setText(element, data.messages.unknown_dispatch); });
    } finally {
      checkoutBusy = false;
      button.removeAttribute('aria-busy');
      allowCheckout = false;
    }
  }, true);
  ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh'].forEach(name => document.addEventListener(name, refresh));
  document.addEventListener('shopify:cart:lines-update', event => {
    const completed = event.promise || Promise.resolve();
    completed.then(refresh).catch(refresh);
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  setInterval(() => { if (!document.hidden) scheduleUpdate(); }, 1000);
  setInterval(() => { if (!document.hidden && (data.product || core.cartState(data.items).state !== 'unmanaged')) refresh(); }, 60000);
  new MutationObserver(scheduleUpdate).observe(document.body, { childList: true, subtree: true });
  initial.dataset.cjsFulfilmentReady = 'true';
  update();
  if (core.isManaged(data.product) || data.items.some(item => core.isManaged(item.variant))) refresh();
})();
